import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChatTakedown = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-message-circle-more-icon lucide-message-circle-more",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 12h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 12h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 12h.01" })
	]
});
export default SvgChatTakedown;
